import { apiRequest } from "./client";

export const securityApi = {
  overview({ days = 30, limit = 24 } = {}) {
    const params = new URLSearchParams({ days: String(days), limit: String(limit) });
    return apiRequest(`/security/overview?${params.toString()}`);
  },

  revokeOtherSessions() {
    return apiRequest("/security/revoke-other-sessions", { method: "POST" });
  },
};
